/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  EditorConfig,
  ElementNode,
  LexicalEditor,
  LexicalNode,
  NodeKey,
  SerializedElementNode,
  Spread,
} from 'lexical';

type SerializedBlockNode = Spread<
  {
    classes?: string[];
  },
  SerializedElementNode
>;

export function convertDivElement(
  domNode: HTMLDivElement,
): DOMConversionOutput | null {
  const node = $createBlockNode();
  return {
    node,
  };
}

export class BlockNode extends ElementNode {
  __classes: string[];

  constructor(classes?: string[], key?: NodeKey) {
    super(key);
    this.__classes = classes ?? [];
  }

  static getType(): string {
    return 'block';
  }

  static clone(node: BlockNode): BlockNode {
    return new BlockNode(node.__classes, node.__key);
  }

  createDOM(config: EditorConfig, editor: LexicalEditor): HTMLElement {
    const dom = document.createElement('div');
    dom.classList.add('Block');
    this.__classes.forEach((className) => {
      dom.classList.add(className);
    });
    return dom;
  }

  static importDOM(): DOMConversionMap<HTMLDivElement> | null {
    return {
      div: (domNode: HTMLDivElement) => ({
        conversion: convertDivElement,
        priority: 1,
      }),
    };
  }

  static importJSON(serializedNode: SerializedBlockNode): BlockNode {
    const node = $createBlockNode(serializedNode.classes);
    return node;
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('div');
    return { element };
  }

  exportJSON(): SerializedBlockNode {
    return {
      ...super.exportJSON(),
      classes: this.__classes?.length ? this.__classes : undefined,
      type: 'block',
      version: 1,
    };
  }
}

export function $createBlockNode(classes?: string[]): BlockNode {
  return new BlockNode(classes);
}

export function $isBlockNode(
  node: LexicalNode | null | undefined,
): node is BlockNode {
  return node instanceof BlockNode;
}
